import http from "./http-common";

class TeamDataService {
  getAll(params) {
    return http.get("/team", { params });
  }

  getAllTeamsFromManager(id) {
    return http.get(`/team/findAllTeamsFromManager/${id}`);
  }

  get(id) {
    return http.get(`/team/${id}`);
  }

  createTeam(data) {
    return http.post("/team", data);
  }

  joinTeam(id, key) {
    return http.get(`/team/join/${id}/${key}`);
  }

  addAdmin(idUser, idTeam) {
    return http.get(`/team/addAdmin/${idUser}/${idTeam}`);
  }

  removeAdmin(idUser, idTeam) {
    return http.get(`/team/removeAdmin/${idUser}/${idTeam}`);
  }

  addActivity(idActivity, idTeam) {
    return http.get(`/team/addActivity/${idActivity}/${idTeam}`);
  }

  removeActivity(idActivity, idTeam) {
    return http.get(`/team/removeActivity/${idActivity}/${idTeam}`);
  }

  update(id, data) {
    return http.put(`/team/${id}`, data);
  }

  delete(id) {
    return http.delete(`/team/${id}`);
  }

  removeUser(idTeam, idUser) {
    return http.get(`/team/removeUser/${idTeam}/${idUser}`);
  }
}

export default new TeamDataService();
